import { NgModule } from '@angular/core';
import { CursorDirective } from '@app/shared/directives/cursor/cursor.directive';

@NgModule({
  exports: [CursorDirective],
  declarations: [CursorDirective]
})
export class CursorModule {}
